export const CONTENT_TYPE = {
    VIDEO: 1,
    TEXT: 2,
    IMAGE: 3,
    AUDIO: 4,
};

export const CONTENT_STATUS = {
    IN_REVIEW: 1,
    CONFIRMED: 2,
    REJECTED: 3,
    DRAFT: 4,
};

export const CONTENT_SOURCE = {
    FILE: "file",
    YOUTUBE: "youtube",
    APARAT: "aparat",
    LINK: "link",
};

export const CONTENT_TARGET = {
    GENERAL: "general",
    SURVEY: "survey",
    ITEM_TYPE: "item_type",
    ITEM: "item",
};

export const STUDIO_SECTIONS = ["library", "send", "analytics"];
export const MAX_FILE_BYTES = 50 * 1024 * 1024;
export const PAGE_SIZE = 12;

export const STATUS_KEY = {
    [CONTENT_STATUS.DRAFT]: "draft",
    [CONTENT_STATUS.IN_REVIEW]: "pending",
    [CONTENT_STATUS.CONFIRMED]: "published",
    [CONTENT_STATUS.REJECTED]: "rejected",
};

export const TYPE_KEY = {
    [CONTENT_TYPE.VIDEO]: "video",
    [CONTENT_TYPE.AUDIO]: "audio",
    [CONTENT_TYPE.IMAGE]: "image",
    [CONTENT_TYPE.TEXT]: "text",
};
